export default __webpack_public_path__ + "static/multi-step-7f306c3813e91ab3fa6480b88209892e.png";